module.exports = __webpack_public_path__ + "images/royal-canin.sprite-brand1-xs.608ebd0be0b3ca1fbcc5ec03135ca064.svg";